import { z } from 'zod'

export const currentPregnancySchema = z.object({
  id: z.string().optional(),
  lmp: z.string()
    .date()
    .nullish()
    .default(null),
  edc: z.string()
    .date()
    .nullish()
    .default(null),
  delivered: z.boolean().nullish()
}).refine(
  ({ lmp, delivered, edc }) => (!!lmp || !!delivered) && !(lmp && delivered),
  { message: 'One of the fields must be defined' }
)

export type CurrentPregnancy = z.infer<typeof currentPregnancySchema>
